












import { Vue, Component } from 'vue-property-decorator';
import BudtenderNavbar from '@/components/budtender/BudtenderNavbar.vue';
import budtenderModule from '../../store/modules/budtender.module';
import errorModule from '../../store/modules/error.module';

@Component({
  components: {
    BudtenderNavbar,
  },
})
export default class BudtenderRoot extends Vue {
  async created(): Promise<void> {
    await budtenderModule.fetchBudtender();
    if (errorModule.hasError) {
      errorModule.clearError();
    }
  }
}
